import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import RouterSuspense from '~/app/common/RouterSuspense';
import List from './';
import ProjectDetail from './Detail';
import { useStoreState } from '~/store';
import { ROUTES } from '~/app/Router';

export const PROJECTS_ROUTES = {
    projects: '/',
    list: '/projects',
    detail: '/project-chat/:projectId',
};

export type RouterComponent = React.FC

const Router: RouterComponent = () => {
    const netWorkStatus = useStoreState(state => state.app.offline.status);

    return (
        <RouterSuspense>
            <Switch>
                {netWorkStatus === 0 ? (
                    <Route exact path={PROJECTS_ROUTES.detail} component={ProjectDetail} />
                ) : (
                    <Redirect from={PROJECTS_ROUTES.detail} to={ROUTES.projects} />
                )}
                <Route path={[PROJECTS_ROUTES.projects, PROJECTS_ROUTES.list]} component={List} />
            </Switch>
        </RouterSuspense>
    );
};

export default Router;